import script from "./Accessibility.vue?vue&type=script&setup=true&lang=js"
export * from "./Accessibility.vue?vue&type=script&setup=true&lang=js"

import "./Accessibility.vue?vue&type=style&index=0&id=61ff3906&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ff3906"]])

export default __exports__